import Swal from 'sweetalert2';
import $http from '../axios-instance';
import store from '../store/store';

export function validateVersion(version) {
    if(!localStorage.getItem('update-version-time')){
        localStorage.setItem('update-version-time',new Date().getTime());
        localStorage.setItem('notify-version',true);
        viewInfo(version);
    }
    if((new Date().getTime() - localStorage.getItem('update-version-time')) > 300000 && localStorage.getItem('notify-version') == 'false'){
        localStorage.setItem('notify-version',true);
        viewInfo(version);
    }

}

function viewInfo(version) {
    const showCancel = window.location.hash.includes("/inicio");

    Swal.fire({
        title:"Actualización del Aplicativo",
        html: '<div style="text-align:justify;"><br>Estimado/a usuario/a,<br><br>Es un placer informarle que nuestro aplicativo ha sido actualizado a la versión <b>'+version+'</b> con nuevas funcionalidades y mejoras que esperamos sean de su agrado y le permitan tener una experiencia aún más satisfactoria.<br><br>Le invitamos a actualizar su aplicativo para disfrutar de todas las nuevas funcionalidades. Si tiene alguna duda o inconveniente, no dude en contactar con nuestro equipo de soporte.<br><br>Atentamente,<br><b>Mejora & Soluciones</b>.<br></div>',
        showConfirmButton: true,
        showCancelButton: !showCancel,
        confirmButtonText: 'Actualizar',
        cancelButtonText: 'Cancelar',
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false
    }).then((result)=>{
        if (result.isConfirmed) {
            upgradesystem();
        }
        if(result.isDismissed) {
            localStorage.setItem('notify-version',false);
            localStorage.setItem('update-version-time',new Date().getTime());
        }
    });
}


/**
 * Reintentar proceso de aceptación de la versión.
 *
 * @author Libardo bolaño
 * @author 2 - Fernando Claros
 */
async function upgradesystem() {
    store.commit('dashboard/load', true, { root: true });

    await $http.post('versions/update', {
            userAgent: navigator.userAgent
        }).then(() => {
            try {
                localStorage.clear();
                caches.keys()
                    .then(function (cacheNames) {
                        cacheNames.forEach(function (cacheName) {
                            caches.delete(cacheName);
                        });
                    });
                location.assign(`${location.origin}/#/login`);
                location.reload(true);
            } catch ($e) {
                console.error("Aceptación de la versión: ", $e);
            }
        })
        .catch(() => retryProcess())
        .finally(() => store.commit('dashboard/load', false, { root: true }))
}

/**
 * Reintentar proceso de aceptación de la versión.
 *
 * @author Fernando Claros
 */
function retryProcess() {
    Swal.fire({
        title: "Actualización del Aplicativo",
        text: "No fue posible actualizar la versión de Soluquim.",
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: 'Reintentar',
        cancelButtonText: 'Cancelar'
    }).then(async (result) => {
        if (result.isConfirmed) {
            await upgradesystem();
        }
        if (result.isDismissed) {
            try {
                localStorage.setItem('notify-version', false);
                localStorage.setItem('update-version-time', new Date().getTime());
            } catch ($e) {
                console.error("Actualización del Aplicativo: ", $e);
            }
        }
    });
}
